const PbxxRecord = require('../pbxx_record')

module.exports = class TwitterShare extends PbxxRecord {
  static get class_name() {
    return 'TwitterShare'
  }
}
